import { useRef } from "react";
import { useInfo } from "src/hooks/useData";
import Layout from "src/components/Layout";
import { useFullscreen } from "src/hooks/useFullScreen";
import Scenarios from "./Scenarios";

import Map from "./Map";
import IncomeSection from "./IncomeSection";
import { Income, ScenarioSettings } from "src/types";

const MapTab = ({ name, active, setActive }: any) => {
  return (
    <div
      className={`${active ? "bg-main-orange text-white" : "bg-white"} py-2 flex items-center justify-center w-64 cursor-pointer rounded-md shadow-md border`}
      onClick={setActive}
    >
      {name}
    </div>
  );
};

const Summary = () => {
  const { data, updateScenario, setField } = useInfo();
  const mapTab = data.liveSettings.mapPage;

  const tab = data.liveSettings.shownScenario;

  const mapScrollRef = useRef(0);
  const incomeScrollRef = useRef(0);
  const { isFullscreen } = useFullscreen();
  const scenarios = data.scenarios;

  const setMapTab = (mapTab: "income" | "map") => {
    setField("liveSettings")({
      ...data.liveSettings,
      mapPage: mapTab,
    });

    if (mapTab === "map") {
      window.scrollTo({ top: mapScrollRef.current });
    } else {
      window.scrollTo({ top: incomeScrollRef.current });
    }
  };

  const init = scenarios.find(({ id }) => id === tab) as any;

  const settings = {
    ...init,
    inflationType: data.liveSettings.inflationType,
    mapType: data.liveSettings.mapType,
    monthlyYearly: data.liveSettings.monthlyYearly,
    chartType: data.liveSettings.chartType,
    maxYearsShown: data.liveSettings.maxYearsShown,
    taxType: data.liveSettings.taxType,
    showTaxType: data.liveSettings.showTaxType,
    scenarioShown: data.liveSettings.shownScenario,
    people: data.people,
    chartFirst: data.liveSettings.chartFirst,
  };
  console.log("sett", settings, init);

  const setSettings = (settings: Partial<ScenarioSettings>) => {
    updateScenario(tab, { ...settings });
  };

  const updateIncomes = (incomes: Income[]) => {
    updateScenario(tab, { incomes });
  };

  return (
    <Layout page="map" noPadding>
      <div className="pb-32 ">
        <div className={`sticky z-50 ${isFullscreen ? "top-0" : "top-[72px]"}`}>
          <div
            className={`flex sticky ${isFullscreen ? "top-[0px]" : "top-[70px]"} gap-2 z-50000 bg-gray-100 py-5 w-full justify-center `}
          >
            <MapTab
              name="Income"
              active={mapTab === "income"}
              setActive={() => setMapTab("income")}
            />

            <MapTab
              name="Map"
              active={mapTab === "map"}
              setActive={() => setMapTab("map")}
            />
          </div>
          <Scenarios
            tab={tab}
            setTab={(tab: number) =>
              setField("liveSettings")({
                ...data.liveSettings,
                shownScenario: tab,
              })
            }
          />

          {init && mapTab === "map" && (
            <Map
              settings={settings}
              setMapScroll={(scroll: any) => (mapScrollRef.current = scroll)}
            />
          )}
          {init && mapTab === "income" && (
            <IncomeSection
              settings={settings}
              setSettings={setSettings}
              updateIncomes={updateIncomes}
              setIncomeScroll={(scroll: any) =>
                (incomeScrollRef.current = scroll)
              }
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Summary;
